<div class="modal-header pb-0">
    <p>Description</p>
    <button class="fa fa-times" [mat-dialog-close]="" style="cursor: pointer;background: none;"
        aria-hidden="true"></button>
</div>
<div class="modal-body">
    <div>
        <p [innerHTML]="showText(data)"></p>
    </div>
</div>



<!-- <span>{{this.data}}</span> -->